import React, { Ref } from "react";
import classnames from "classnames";
import styles from "./IconButton.module.scss";

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
  className?: string;
  icon: React.ComponentType<{ className?: string }>;
  onClick?: (e: React.MouseEvent) => void;
}

export const IconButton = React.forwardRef(
  (
    { className, icon, onClick, ariaLabel, ...props }: IconButtonProps,
    ref: Ref<HTMLButtonElement>
  ) => {
    const Icon = icon;

    const cls = classnames(className, styles.iconButton);

    return (
      <button
        ref={ref}
        aria-label={ariaLabel}
        type="button"
        className={cls}
        onClick={onClick}
        {...props}
      >
        <Icon className={styles.icon} />
      </button>
    );
  }
);

IconButton.displayName = "IconButton";
